/**
 * /superadmin — Platform area layout (the Platform Support Console).
 *
 * Platform-scoped, NOT tenant-scoped: it lives OUTSIDE the
 * `/app/$tenantSlug/*` tree because a super_admin has no active tenant.
 * The parent `_authgated` gate only bounces unauthenticated and
 * identity-only (user_id===0) callers; a platform super_admin (real
 * user_id, role super_admin, no tenant) passes through, and the bounce
 * effect only fires for `/app/*` paths, so `/superadmin/*` is safe under
 * it. PlatformShell then applies the super_admin role gate (the UX
 * mirror of the backend RequireRole on every /api/v1/admin/* route).
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";
import { PlatformShell } from "@/components/superadmin/platform-shell";

export const Route = createFileRoute("/_authgated/superadmin")({
  component: PlatformLayout,
});

function PlatformLayout() {
  return (
    <PlatformShell>
      <Outlet />
    </PlatformShell>
  );
}
